<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="columns is-vcentered">
          <div class="column is-half">
            <h1 class="title is-size-1">Play With Fake Digital Currency!</h1>
            <h2 class="subtitle is-size-3">Ditch the paper and play Monopoly FASTER and with EASE with Fake Digital Currency.</h2>
            <button @click="play" class="button is-primary is-large is-hidden-mobile">Play Now!</button>
            <button @click="play" class="button is-primary is-large is-fullwidth is-hidden-desktop is-hidden-tablet-only">Play Now!</button>
          </div>
          <div class="column is-half">
            <img src="/img/monopoly-cta.png" alt="Monopoly Wallet" />
          </div>
        </div>
      </div>
    </section>
    <hr />
    <section>
      <div class="columns">
        <div class="column">
          <div class="box">
            <div class="columns">
              <div class="column is-one-third">
                <img class="image" src="/img/balance.png" />
              </div>
              <div class="column">
                <h3 class="title is-size-3">View Realtime Balance</h3>
              </div>
            </div>
            <p>View your realtime Monopoly Wallet balance after all transactions.</p>
          </div>
        </div>
        <div class="column">
          <div class="box">
            <div class="columns">
              <div class="column is-one-third">
                <img class="image" src="/img/log.png"/>
              </div>
              <div class="column">
                <h3 class="title is-size-3">View Transaction Logs</h3>
              </div>
            </div>
            <p>View all transactions i.e. money in and out of your Monopoly Wallet.</p>
          </div>
        </div>
        <div class="column">
          <div class="box">
            <div class="columns">
              <div class="column is-one-third">
                <img class="image" src="/img/transfer.png"/>
              </div>
              <div class="column">
                <h3 class="title is-size-3">Transfer Digital Funds</h3>
              </div>
            </div>
            <p>During game play transfer funds to other Players and the Banker in exchange for Monopoly property.</p>
          </div>
        </div>
      </div>
    </section>
    <hr />
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="columns is-vcentered">
          <div class="column is-half">
            <h1 class="title is-size-1">Using Monopoly Wallet Is Simple!</h1>
            <h2 class="subtitle is-size-3">Monopoly Wallet lets players track transactions, manage balances, and
              transfer money digitally—all in real-time during the game.</h2>
          </div>
          <div class="column is-half">
            <img src="/img/monopoly-how.png" alt="How To Use" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import router from "../router";

export default {
  mounted: function () { },
  methods: {
    play: function () {
      router.replace({ path: "home" });
    },
  },
}
</script>

<style scoped>
.title {
  color: #333;
}

.subtitle {
  color: #666;
}

.button {
  margin-top: 20px;
}

.image {
  border-radius: 8px;
}
</style>